import InitiateTransferAction from "./initiateAssetTransfer/InitiateTransferAction.js";
import RejectTransferAction from "./completeAssetTransfer/RejectTransferAction.js";
import AcceptTransferAction from "./completeAssetTransfer/AcceptTransferAction.js";
import CancelTransferAction from "./completeAssetTransfer/CancelTransferAction.js";
export default {
  install: molten => {
    molten.addPlugin('Action', InitiateTransferAction);
    molten.addPlugin('Action', AcceptTransferAction);
    molten.addPlugin('Action', RejectTransferAction);
    molten.addPlugin('Action', CancelTransferAction);
  }
};